import React from "react";
import { Tooltip } from "antd";
import { LuCheck, LuX } from "react-icons/lu";
import type { MutationOp } from "./types";

const MutationChip: React.FC<{ op: MutationOp }> = ({ op }) => {
  const hasError = !!op.error;
  const chip = (
    <span className={`sandbox-ai-chip${hasError ? " sandbox-ai-chip-error" : ""}`}>
      {hasError ? (
        <LuX className="sandbox-ai-chip-icon" />
      ) : (
        <LuCheck className="sandbox-ai-chip-icon" />
      )}
      <span className="sandbox-ai-chip-label">{op.label}</span>
    </span>
  );

  if (!hasError) return chip;
  return (
    <Tooltip title={op.error} overlayClassName="sandbox-ai-tooltip" mouseEnterDelay={0.15}>
      {chip}
    </Tooltip>
  );
};

export default MutationChip;
